export default "__VITE_ASSET__DBcmHPOM__"